import React from "react";

const PrivacyPolicyPage = () => {
  return (
    <div className="privacy-policy-area space">
      <div className="container">
        <h2 className="mb-4">Privacy Policy</h2>
        <p>
          At Gowrisankar Agencies, we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and safeguard your personal information when you visit our website or use our services.
        </p>

        <h4>1. Information We Collect</h4>
        <p>
          We may collect personal information such as your name, email address, phone number, and address when you contact us, make a purchase, or fill out a form on our website.
        </p>

        <h4>2. How We Use Your Information</h4>
        <p>
          The information we collect is used to:
          <ul>
            <li>Respond to inquiries and provide customer support</li>
            <li>Process transactions and deliver products</li>
            <li>Improve our services and user experience</li>
            <li>Send updates, offers, and promotions (only with your consent)</li>
          </ul>
        </p>

        <h4>3. Data Protection</h4>
        <p>
          We implement industry-standard security measures to protect your data. Your personal information is stored securely and is not shared with third parties except for order fulfillment or when required by law.
        </p>

        <h4>4. Cookies</h4>
        <p>
          Our website may use cookies to enhance user experience and analyze traffic. You can disable cookies in your browser settings.
        </p>

        <h4>5. Third-Party Services</h4>
        <p>
          We may use third-party services like payment gateways or analytics tools. These providers have their own privacy policies, which we recommend reviewing.
        </p>

        <h4>6. Your Rights</h4>
        <p>
          You have the right to access, modify, or delete your personal data at any time. Please contact us if you wish to make such a request.
        </p>

        <h4>7. Contact Us</h4>
        <p>
          If you have any questions about this Privacy Policy, please contact us at:  
          <br />
          <strong>Email:</strong> <a href="mailto:rajesh.katakam@gmail.com">rajesh.katakam@gmail.com</a>  
          <br />
          <strong>Phone:</strong> <a href="tel:09248022760">092480 22760</a>
        </p>

        <p className="mt-4">
          This Privacy Policy was last updated on June 13, 2025.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
